<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Pré Fatura Despesa</h4>
              <span
                >Insira todos os dados nos filtros para obter os
                resultados</span
              >
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 400px">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="table-responsive">
                  <b-col md="6" offset-md="6">
                    <b-row no-gutters>
                      <b-col class="p-0">
                        <!-- <AvisoErros v-bind:errors_array="errors_array"></AvisoErros> -->
                        <div class="loadingData" v-if="loadingDataStore">
                          <div class="loadingDataSpinner">
                            <spinner
                              v-if="loadingDataStore"
                              text-fg-color="#ffffff"
                              message="Carregando..."
                            ></spinner>
                          </div>
                        </div>
                      </b-col>
                      <b-col class="p-0">
                        <label>Vlr. total nfs</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_nfs"
                          placeholder="Vlr. total nfs"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: 'R$ ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-button
                        @click="onStore()"
                        style="height: 40px; place-self: end"
                        >Associar</b-button
                      >
                    </b-row>
                  </b-col>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('gerarprefaturadespesa.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/gerarprefaturadespesa"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="doctransp_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="unidade-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="dt_emissao" slot-scope="props">
                      <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import PreFaturaDespesaFilterBarVue from "./PreFaturaDespesaFilterBar.vue";

// Vue.component('unidade-detalhes', UnidadeDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": PreFaturaDespesaFilterBarVue,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loadingDataStore: false,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      optionsTpDoc: [],
      filter_data_store: {},
      filtros_form: new Form({
        tp_doc: "",
        transportadora: "",
        dt_emissao_ini: "",
        dt_emissao_fim: "",
      }),
      form: new Form({
        vlr_total_nfs: 0,
        docs: [],
      }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "doc_transp_partes_env.emitente_pessoa_juridica.razao_social",
          title: "Transportadora",
          sortField:
            "doc_transp_partes_env.emitente_pessoa_juridica.razao_social",
        },
        {
          name: "num_doc",
          title: "N° Fiscal",
          sortField: "num_doc",
        },
        {
          name: "serie",
          title: "Série",
          sortField: "serie",
        },
        {
          name: "__slot:dt_emissao",
          title: "Data Emissão",
          sortField: "dt_emissao",
        },
        {
          name: "liv_tp_doc.descr",
          title: "Tipo de Documento",
          sortField: "liv_tp_doc.descr",
        },
        {
          name: "doc_transp_vlr_prestacao.vlr_receber",
          title: "Valor CTE/RPS",
          sortField: "vlr_receber",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        console.log("this.filter_data_store");
        console.log(this.filter_data_store);
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.tp_doc = this.filter_data_store.tp_doc;
          this.filtros_form.transportadora =
            this.filter_data_store.transportadora;
          this.filtros_form.dt_emissao_ini =
            this.filter_data_store.dt_emissao_ini;
          this.filtros_form.dt_emissao_fim =
            this.filter_data_store.dt_emissao_fim;

          this.filtros_form
            .post("/api/gerarprefaturadespesa/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        dt_emissao_ini: data_filter.dt_emissao_ini,
        dt_emissao_fim: data_filter.dt_emissao_fim,
        tp_doc: data_filter.tp_doc.value,
        transportadora: data_filter.transportadora.value,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.$watch(
        () => {
          return this.$refs.vuetable.selectedTo;
        },
        (obj) => {
          this.somaValoresNfs(obj);
        }
      );
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.unidade_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.docs = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form.docs.push({ doctransp_id: obj });
      });
      this.form
        .put("/api/gerarprefaturadespesa/store")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/gerarprefaturadespesa/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.tp_doc.forEach((obj) => {
            this.optionsTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    somaValoresNfs(obj) {
      this.form.vlr_total_nfs = 0;
      obj.forEach((item, i) => {
        this.data = this.dataExport.filter(
          (item2) => item2.doctransp_id === item
        );
        this.form.vlr_total_nfs =
          parseFloat(this.data[0].doc_transp_vlr_prestacao.vlr_receber) +
          this.form.vlr_total_nfs;
      });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
